import './index.scss';
import React, { useState } from 'react';
import PermissionChecker from '~/components/permission_checker/index';
import { useAppSidebar } from '~/layout/main_layout/app_sidebar/provider';
import { NotificationProvider } from '~/providers/notifications';
import { useUser } from '~/providers/user';
import Permissions from '~/settings/permissions';
import CogMenu from './cog_menu';
import HeaderLink from './header_link';
import NotificationMenu from './notification_menu';
import OldUploadDocumentModalWrapper from './old_upload_document_modal';
import OrgSwitcher from './org_switcher';
import SearchBar from './search_bar';
import UploadDocumentModal from './upload_document_modal';
const Header = () => {
    const { isCollapsed, setIsCollapsed } = useAppSidebar();
    const [isModalVisible, setIsModalVisible] = useState(false);
    const showModal = () => setIsModalVisible(true);
    const hideModal = () => setIsModalVisible(false);
    const { name, useNewView } = useUser();
    return React.createElement("div", { className: 'rg-header' },
        React.createElement("div", { className: 'left' },
            !useNewView &&
                React.createElement("div", { className: isCollapsed ? 'app-menu-close' : 'app-menu-open', onClick: () => setIsCollapsed(!isCollapsed) }),
            React.createElement("div", { className: 'nav-logo' },
                React.createElement(HeaderLink, { path: '/' },
                    React.createElement("img", { className: 'logo', src: '/icons/ClauseLink_Logo.png', alt: 'ClauseLink' }))),
            React.createElement("div", { className: 'search' },
                React.createElement(SearchBar, null))),
        React.createElement("div", { className: 'right' },
            React.createElement(PermissionChecker, { requiredAnyPermissions: [Permissions.UPLOAD_FILE] },
                React.createElement("div", { "data-public": true, className: 'add-document', onClick: showModal }, "Add document")),
            React.createElement("div", { className: 'user-info-wrapper' },
                React.createElement("div", { className: 'user-info' },
                    "Hi, ",
                    name,
                    React.createElement(OrgSwitcher, null)),
                React.createElement(NotificationProvider, null,
                    React.createElement(NotificationMenu, null)),
                React.createElement(CogMenu, null))),
        useNewView
            ? React.createElement(UploadDocumentModal, { isModalVisible: isModalVisible, hideModal: hideModal })
            : React.createElement(OldUploadDocumentModalWrapper, { isModalVisible: isModalVisible, hideModal: hideModal }));
};
export default Header;
